"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var services_1 = require("../../services");
var abstract_destruction_subject_1 = require("../abstract-destruction-subject");
require("./header-information-group.component.scss");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var platform_browser_1 = require("@angular/platform-browser");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var HeaderInformationGroupComponent = /** @class */ (function (_super) {
    __extends(HeaderInformationGroupComponent, _super);
    function HeaderInformationGroupComponent(_kbService, _classifierService, messageService, formattingService, currentLanguageProvider, titleService) {
        var _this = _super.call(this) || this;
        _this._kbService = _kbService;
        _this._classifierService = _classifierService;
        _this.messageService = messageService;
        _this.formattingService = formattingService;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.titleService = titleService;
        _this.title_msg = null;
        _this.entityName = null;
        _this.createdUserFieldName = 'CreatedUserID';
        _this._hasWorkflow = false;
        _this._workFlowState = '';
        _this.createdMessage$ = new ReplaySubject_1.ReplaySubject(1);
        _this.modifiedMessage$ = new ReplaySubject_1.ReplaySubject(1);
        return _this;
    }
    Object.defineProperty(HeaderInformationGroupComponent.prototype, "hasWorkflow", {
        get: function () {
            return this._hasWorkflow;
        },
        set: function (value) {
            this._hasWorkflow = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderInformationGroupComponent.prototype, "metaFields", {
        get: function () {
            return this._metaFields;
        },
        set: function (value) {
            this._metaFields = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderInformationGroupComponent.prototype, "lastUpdatedUser", {
        get: function () {
            return this._lastUpdatedUser;
        },
        set: function (value) {
            this._lastUpdatedUser = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderInformationGroupComponent.prototype, "workFlowState", {
        get: function () {
            return this._workFlowState;
        },
        set: function (value) {
            this._workFlowState = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderInformationGroupComponent.prototype, "nameMeasure", {
        get: function () {
            return this._nameMeasure;
        },
        set: function (value) {
            this._nameMeasure = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderInformationGroupComponent.prototype, "createdUser", {
        get: function () {
            return this._createdUser;
        },
        set: function (value) {
            this._createdUser = value;
        },
        enumerable: true,
        configurable: true
    });
    HeaderInformationGroupComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes['entity'] && this.entity) {
            this.handleViewData()
                .pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function () {
                if (_this._titleDisplayName) {
                    _this.titleService.setTitle(_this._titleDisplayName.getValue(_this.currentLanguageId));
                }
            }, function (err) { return console.error(err); });
        }
    };
    HeaderInformationGroupComponent.prototype.getLastUpdatedDate = function () {
        return this.entity
            ? this.entity.getProperty('DateUpdated').value
            : undefined;
    };
    HeaderInformationGroupComponent.prototype.getCreatedDate = function () {
        return this.entity
            ? this.entity.getProperty('DateCreated').value
            : undefined;
    };
    HeaderInformationGroupComponent.prototype.getTitle = function () {
        var _this = this;
        if (this.title_msg) {
            if (this.nameMeasure) {
                return this.messageService
                    .getMessage(this.title_msg)
                    .pipe(operators_1.map(function (message) {
                    return message + (" : " + _this.nameMeasure);
                }));
            }
            return this.messageService.getMessage(this.title_msg);
        }
        else if (this.caption) {
            if (this.nameMeasure) {
                return of_1.of(this.caption + " : " + this.nameMeasure);
            }
            return of_1.of(this.caption);
        }
        return of_1.of('');
    };
    HeaderInformationGroupComponent.prototype.getModifiedMessage = function () {
        return this.modifiedMessage$;
    };
    HeaderInformationGroupComponent.prototype.getCreatedMessage = function () {
        return this.createdMessage$;
    };
    Object.defineProperty(HeaderInformationGroupComponent.prototype, "titleDisplayName", {
        get: function () {
            return this._titleDisplayName;
        },
        enumerable: true,
        configurable: true
    });
    HeaderInformationGroupComponent.prototype.handleViewData = function () {
        var _this = this;
        var updatedUserClassifierEntity = this.entity
            ? this.entity.getProperty('UpdatedUserID').value
            : undefined;
        var createdUserClassifierEntity = this.entity
            ? this.entity.getProperty(this.createdUserFieldName)
                .value
            : undefined;
        var lastUpdatedUser$ = updatedUserClassifierEntity
            ? this._classifierService.getEntityName('User', updatedUserClassifierEntity)
            : of_1.of('');
        var createdUser$ = createdUserClassifierEntity
            ? this._classifierService.getEntityName('User', createdUserClassifierEntity)
            : of_1.of('');
        var nameMeasure$ = this.entityName
            ? of_1.of(this.entityName)
            : this._classifierService.getEntityName(this.categoryName, this.entity);
        var metaFields$ = this._kbService.getMetaFields(this.categoryName);
        var titleDisplayName$ = this._kbService
            .getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(this.categoryName))
            .pipe(operators_1.map(function (metaCategory) {
            return metaCategory.getDisplayNameMultilingual();
        }));
        var titleMsg$ = this.title_msg
            ? of_1.of(this.title_msg)
            : this._kbService
                .getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(this.categoryName))
                .pipe(operators_1.map(function (metaCategory) {
                return metaCategory.getDisplayNameMsgId();
            }));
        var currentLanguageId$ = this.currentLanguageId
            ? of_1.of(this.currentLanguageId)
            : this.currentLanguageProvider
                .getCurrentLanguage()
                .pipe(operators_1.map(function (language) { return language.getId(); }));
        return zip_1.zip(lastUpdatedUser$, createdUser$, nameMeasure$, titleMsg$, metaFields$, titleDisplayName$).pipe(operators_1.mergeMap(function (data) {
            _this._lastUpdatedUser = data[0];
            _this._createdUser = data[1];
            _this._nameMeasure = data[2];
            _this.title_msg = data[3];
            _this._metaFields = data[4];
            if (data[5] && _this.nameMeasure && _this.nameMeasure.trim()) {
                var displayNameMap_1 = new Map();
                var concatNameMeasure_1 = " : " + _this.nameMeasure;
                data[5]
                    .toMap()
                    .forEach(function (value, key) {
                    return displayNameMap_1.set(key, value + concatNameMeasure_1);
                });
                _this._titleDisplayName = new idm_crosscutting_concepts_frontend_1.MultilingualStringBuilder()
                    .fromMap(displayNameMap_1)
                    .build();
            }
            else {
                _this._titleDisplayName = data[5];
            }
            var workflowState$ = of_1.of('');
            var createdMessage$ = of_1.of('');
            var updatedMessage$ = of_1.of('');
            var wfState = _this.getWfStateField(_this.metaFields);
            if (wfState) {
                _this._hasWorkflow = true;
                var workflowStateFieldName = wfState.getSystemName();
                var workflowStateCompoundName = wfState.getCompoundCategorySystemName();
                var workflowEntity = _this.entity
                    ? _this.entity.getProperty(workflowStateFieldName).value
                    : undefined;
                if (workflowEntity) {
                    workflowState$ = _this._classifierService.getEntityName(workflowStateCompoundName, workflowEntity);
                }
            }
            if (_this.getCreatedDate()) {
                createdMessage$ = _this.formattingService
                    .formatDateTime(_this.getCreatedDate().valueOf())
                    .pipe(operators_1.mergeMap(function (date) {
                    return _this.messageService.getMessageWithPlaceholder('de_header_created', [date, _this.createdUser]);
                }));
            }
            if (_this.getLastUpdatedDate()) {
                updatedMessage$ = _this.formattingService
                    .formatDateTime(_this.getLastUpdatedDate().valueOf())
                    .pipe(operators_1.mergeMap(function (date) {
                    return _this.messageService.getMessageWithPlaceholder('de_header_modified', [date, _this.lastUpdatedUser]);
                }));
            }
            return combineLatest_1.combineLatest(workflowState$, createdMessage$, updatedMessage$, currentLanguageId$).pipe(operators_1.map(function (dataNames) {
                _this._workFlowState = dataNames[0];
                _this.createdMessage$.next(dataNames[1]);
                _this.modifiedMessage$.next(dataNames[2]);
                _this.currentLanguageId = dataNames[3];
                return true;
            }));
        }));
    };
    HeaderInformationGroupComponent.prototype.getWfStateField = function (metaFields) {
        var metaField = metaFields.find(function (field) {
            return field.getType() === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE;
        });
        if (!metaField) {
            this._hasWorkflow = false;
            return undefined;
        }
        else {
            this._hasWorkflow = true;
            return metaField;
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderInformationGroupComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderInformationGroupComponent.prototype, "caption", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderInformationGroupComponent.prototype, "title_msg", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderInformationGroupComponent.prototype, "entityName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], HeaderInformationGroupComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderInformationGroupComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HeaderInformationGroupComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderInformationGroupComponent.prototype, "createdUserFieldName", void 0);
    HeaderInformationGroupComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'header-information',
            template: require('./header-information-group.component.html'),
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_message_language_service_client_js_1.MessageService,
            services_1.FormattingService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            platform_browser_1.Title])
    ], HeaderInformationGroupComponent);
    return HeaderInformationGroupComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.HeaderInformationGroupComponent = HeaderInformationGroupComponent;
//# sourceMappingURL=header-information-group.component.js.map